'use client';
import cn from 'classnames';

import './HighlightCardFull.style.scss';
import Button from '@/components/common/Button/Button';
import Link from '@/components/common/Link/Link';
import Text from '@/components/common/Text/Text';
import CMSResponsiveImage from '@/components/common/CMSResponsiveImage/CMSResponsiveImage';
import { CMSResponsiveImageData } from '../component-registry';

type HighlightCardFullProps = {
  className?: string;
  headline: string;
  description: string;
  ctaText?: string;
  ctaLink?: string;
  image: CMSResponsiveImageData;
  isImageAlignedRight?: boolean;
};

function HighlightCardFull(props: HighlightCardFullProps) {
  const {
    className = '',
    headline,
    description,
    ctaText,
    ctaLink,
    image: { mobile: mobileImg, desktop: desktopImg },
    isImageAlignedRight
  } = props;

  return (
    <div
      className={cn(
        'HighlightCardFull',
        { 'HighlightCardFull-img-right': isImageAlignedRight },
        className
      )}
    >
      <CMSResponsiveImage
        className={'HighlightCardFull-image-container'}
        desktopImgClassName={'HighlightCardFull-image-desktop'}
        desktopImgMaintainAspectRatio={false}
        mobileImgClassName={'HighlightCardFull-image-mobile'}
        mobileImgMaintainAspectRatio={true}
        data={{
          mobile: mobileImg,
          desktop: desktopImg
        }}
      />

      <div className='HighlightCardFull-content'>
        <div className='HighlightCardFull-copy'>
          <Text
            className='HighlightCardFull-title'
            variant='title-m'
            italic
          >
            {headline}
          </Text>
          <Text
            className='HighlightCardFull-description'
            variant='text-s'
          >
            {description}
          </Text>
        </div>

        {ctaText && ctaLink && (
          <div className='HighlightCardFull-cta'>
            <Link href={ctaLink}>
              <Button
                variant='underline'
                size='small'
              >
                {ctaText}
              </Button>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}

export default HighlightCardFull;
